import { useSelector } from 'react-redux';
import { markenStandortHasDatSelector, markenStandortSelector, markenstandortHasFahrzeugSpezifischeSucheSelector } from '../../../../../modules/selectors/standort/markenStandort';
import { hideHomeHeroBannerSelector, hideServiceFormSelector, mobileVehicleSelectionSelector } from '../../../../../modules/selectors/standort/theme';
import React, { useEffect, useRef, useState } from 'react';
import HomeHeroBanner from '../../../Home/HomeHeroBanner';
import OfferCategories from '../../../Categories/OfferCategoryCards';
import TopSeller from '../../../TopSeller/TopSeller';
import ServiceCategories from '../../../ServiceCategories/ServiceCategories';
import Meisterkachel from '../../../Meisterkachel/Meisterkachel';
import SubCategoryLinks from '../../../Categories/SubCategoryLinks';
import loadable from '@loadable/component';
import VehicleSelectionMobileToggle from '../../../VehicleSelection/VehicleSelectionMobileToggle';
import VehicleSelectionProducts from '../../../vehicleSelectionProducts/VehicleSelectionProducts';

const CMSTeaser = loadable(() => import('../../../CMSTeaser/CMSTeaser'));
const SubLocationFinder = loadable(() => import('../../../SubLocationFinder/SubLocationFinder'));
const ServiceStationFinder = loadable(() => import('../../../ServiceStationFinder/ServiceStationFinder'));

export default function LegacyHome() {
    const markenStandort = useSelector(markenStandortSelector);
    const hideHomeHeroBanner = useSelector(hideHomeHeroBannerSelector);
    const ServiceCategoriesRef = useRef(null);
    const hideServiceForm = useSelector(hideServiceFormSelector);
    const hasDat = useSelector(markenStandortHasDatSelector);
    const hasFSS = useSelector(markenstandortHasFahrzeugSpezifischeSucheSelector)
    const mobileVehicleSelection = useSelector(mobileVehicleSelectionSelector);
    const [isMobile, setIsMobile] = useState(null);

    useEffect(() => {
        function handleResize() {
            setIsMobile(window.innerWidth < 960);
        }

        if (typeof window !== 'undefined') {
            handleResize();
        } 

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [isMobile]);

    return (
        <>
            {!hideHomeHeroBanner && <HomeHeroBanner />}
            {markenStandort.isTechno ? (
                <div className="uk-section uk-section-default uk-section-small">
                    <div className="uk-container">
                        <h2 className="uk-text-normal">
                            Geben Sie Ihre <b>Postleitzahl</b> ein und Sie erhalten eine Auswahl an Markenwerkstätten in <b>Ihrer Nähe</b>
                        </h2>
                        <ServiceStationFinder />
                    </div>
                </div>
            ) : (
                <SubLocationFinder />
            )}
            <OfferCategories />
            <CMSTeaser h3="Unsere Highlights" previewCategory="main" isMobile={isMobile} />
            {hasDat && isMobile && isMobile !== null && !mobileVehicleSelection && hasFSS && (
                <VehicleSelectionMobileToggle />
            )}
            {hasDat && isMobile && isMobile !== null && mobileVehicleSelection && hasFSS &&(
                <VehicleSelectionMobileToggle />
            )}
            {hasDat && !isMobile && isMobile !== null && hasFSS && (
                <VehicleSelectionMobileToggle />
            )}
            {hasFSS && <VehicleSelectionProducts />}
            <TopSeller />
            {!hideServiceForm && <ServiceCategories ref={ServiceCategoriesRef} />}
            <section className="uk-section uk-section-muted uk-section-small uk-padding">
                <div className="uk-container uk-container-xsmall">
                    <Meisterkachel />
                </div>
            </section>
            <SubCategoryLinks />
        </>
    );
}
